import Cookies from 'js-cookie';

import * as types from '../constants/mutationTypes';
import { cancelPendingRequests } from '../libs/requestCancellation';
import { recordActivity, clearLastActivity } from '../libs/sessionActivity';

export const actions = {
  async setToken({ commit, dispatch }, { token, keep }) {
    commit(types.SET_TOKEN, { token, keep });
    recordActivity();
    await dispatch('getUserInfo');
  },
  signOut({ commit, dispatch }) {
    // 前のユーザーの未解決リクエストの応答が、消去後の一覧に書き戻されないようにする
    cancelPendingRequests();
    commit(types.CLEAR_TOKEN);
    clearLastActivity();
    dispatch('clearUserInfo');
    // 自動ログアウトはページを再読込しないため、代理ログイン状態を残すと次のログインに代理先のヘッダが付く
    dispatch('resetIdentity');
    dispatch('clearUsers');
    dispatch('clearOrganizations');
    dispatch('clearSensors');
  },
};

export const mutations = {
  SET_TOKEN(state, { token, keep }) {
    state.token = token;

    Cookies.set('token', state.token, { expires: keep ? 1 : '' });
  },
  CLEAR_TOKEN(state) {
    state.token = null;

    Cookies.remove('token');
  },
};

export const getters = {
  isSignedIn(state) {
    return !!state.token;
  },
  getAccessToken(state) {
    return state.token;
  },
};

export const state = () => ({
  token: Cookies.getJSON('token'),
});
